import React from 'react';
import { Col, Grid, Row, Typography } from 'antd';
import classNames from 'classnames';

import ImageC from 'src/components/Image';

import classes from './index.module.less';

const point = [
	'Menumbuhkan sel baru untuk regenerasi organ atau jaringan yang rusak',
	'Digunakan untuk meneliti penyebab terjadinya penyakit',
	'Melihat risiko sebuah sel menjadi kanker',
];

const MoreInformation = () => {
	const { md, xl } = Grid.useBreakpoint();
	return (
		<div className="bg-gray">
			<div className="container py-md-5 py-3">
				<Row gutter={{ md: 60, xs: 0 }} justify="end">
					<Col className="d-flex justify-content-md-end justify-content-center" xs={24} md={12}>
						<div>
							<ImageC
								objectFit="contain"
								width={xl ? 512 : 320}
								height={xl ? 698 : 436}
								src="/images/stem-cell/cell-multiple.png"
							/>
						</div>
					</Col>
					<Col xs={24} md={12} className={classes.information}>
						<Typography.Title level={2} className={classes.title}>
							Potensi Penggunaan Stem Cell di Indonesia
						</Typography.Title>
						<Typography.Paragraph className={classNames('my-3', classes.description)}>
							Stem cell di Indonesia dikenal dengan sel punca, yang merupakan basis dari semu sel
							yang ada di dalam tubuh kita. Stem cell dapat merubah diri menjadi sel lain yang
							diyakini dapat membantu berbagai kondisi kesehatan, seperti:
						</Typography.Paragraph>
						{point.map((item: string, index: number) => (
							<Row className="mb-3" key={index} align="top">
								<Col className="d-flex pt-md-2" span={2}>
									<ImageC
										width={xl ? 24 : 18}
										height={xl ? 24 : 18}
										src="/images/stem-cell/icon-arrow-right.png"
									/>
								</Col>
								<Col span={22}>
									<Typography.Paragraph className={classNames('mb-0', classes.description)}>
										<span
											dangerouslySetInnerHTML={{
												__html: item,
											}}
										/>
									</Typography.Paragraph>
								</Col>
							</Row>
						))}
						<Typography.Paragraph
							className={classNames(`${md ? 'fs-14' : 'fs-12'} font-italic`, classes.referensi)}
						>
							Referensi:Food & Drug Administrations. Diakses 2022. FDA Warns About Stem Cell
							Therapies. Stem Cell Investigation. Diakses 2022. Current state of stem cell-based
							therapies: an overview
						</Typography.Paragraph>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default MoreInformation;
